<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header">
                        <div class="d-md-flex align-items-center">
                            <div>
                                <h4 class="card-title">Attachments</h4>
                                <h6 class="card-subtitle">My documents</h6>
                            </div>
                            <div class="ml-auto d-flex no-block align-items-center">
                                <div class="dl">
                                    <div class="button-group">
                                        <router-link :to="{name: 'add-my-credential'}"
                                                     class="btn btn-success waves-effect waves-light">
                                            <i class="fas fa-plus"></i> New Document
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr>
                    <div class="card-body">
                        <b-col class="my-1" lg="6">
                            <b-form-group
                                    class="mb-4"
                                    label="Filter"
                                    label-align-sm="right"
                                    label-cols-sm="1"
                                    label-for="filter-input"
                                    label-size="sm">
                                <b-input-group size="sm">
                                    <b-form-input class="ml-2"
                                                  id="filter-input"
                                                  placeholder="Search by File Name or Title"
                                                  type="search"
                                                  v-model="filter">
                                    </b-form-input>
                                    <b-input-group-append>
                                        <b-button @click="reset()">Clear</b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-form-group>
                        </b-col>

                        <b-col class="my-1" lg="6">

                        </b-col>
                        <b-table :busy="busy" :current-page="currentPage" :fields="fields" :filter="filter"
                                 :filter-included-fields="filterOn"
                                 :items="attachments"
                                 :per-page="perPage"
                                 :sort-by="sortBy" :sort-desc="sortDesc" :sort-direction="sortDirection"
                                 @filtered="onFiltered"
                                 responsive striped tbody-tr-class="rowClass" v-if="totalRows>0">
                            <template #cell(status)="data">
                                <span class="label label-info" v-if="data.value === 'DRAFT'">Draft</span>
                                <span class="label label-dark-green" v-if="data.value === 'SUBMITTED'">Submitted</span>
                            </template>
                            <template #cell(created_at)="data">
                                {{ data.value | date }}
                            </template>
                            <template #cell(year_ending_date)="data">
                                {{ data.value | date }}
                            </template>


                            <template #cell(action)="data">
                                <a @click="downloadFile(data.item)"
                                   class="text-indigo font-18 fa fa-border fa-download"
                                   href="javasript:void(0);">
                                </a>
                                <i @click="attachment_to_delete = data.item"
                                   class="text-danger font-18 fa fa-border fa-trash-alt" data-placement="top"
                                   data-target="#deleteModal" data-toggle="modal" style="cursor: pointer;"
                                   title="Print Smart Card"></i>
                            </template>
                        </b-table>
                        <template v-else>
                            <h4 class="card-title text-muted text-center m-t-30">No records found.</h4>
                            <h5 class="card-title text-muted text-center m-b-30">Change search criteria and try
                                again</h5>
                        </template>
                    </div>
                    <div class="card-footer" v-if="totalRows>5">
                        <div class="row">
                            <div class="col">
                                <per-page :total="totalRows" v-model="perPage"/>
                            </div>
                            <div class="col-auto" v-if="totalRows>perPage">
                                <b-pagination :per-page="perPage" :total-rows="totalRows" v-model="currentPage"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" id="deleteModal" role="dialog" tabindex="-1">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="card card-blue mb-0">
                        <div class="card-body pt-5">
                            <p class="text-center"><i class="fa fa-5x fa-exclamation-triangle text-warning"/></p>
                            <h5 class="my-5">You are about to delete the attachment <b class="text-info"
                                                                                       v-if="attachment_to_delete">{{attachment_to_delete.title}}</b>.
                                Are you sure?</h5>
                            <button @click="removeAttachment" class="btn btn-success float-left" type="button">
                                Yes
                            </button>
                            <button aria-label="Close" class="btn btn-secondary float-right" data-dismiss="modal"
                                    type="button">
                                No
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import Blockie from "../../../common/Blockie";
    import Paginate from 'vuejs-paginate';
    import PerPage from "@/components/protected/common/PerPage.vue";


    export default {
        name: "MyCredentialList",
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        components: {Blockie, Paginate, PerPage},
        data() {
            return {
                pageCount: 1,
                total: 0,
                member: {
                    id: null,
                    biz_name: null
                },
                attachments: [],
                fields: [
                    {
                        key: 'title',
                        sortable: true
                    },
                    {
                        key: 'description',
                    },
                    {
                        key: 'name',
                        label: 'File',
                    },
                    {
                        key: 'created_at',
                        label: 'Created On',
                        sortable: true
                    },
                    {
                        key: 'action',
                        label: 'Action',
                    }
                ],
                busy: false,
                currentPage: 1,
                perPage: 5,
                totalRows: 0,
                sortBy: 'name',
                sortDesc: false,
                sortDirection: 'asc',
                filter: null,
                filter_financial_year: null,
                financial_year_list: [],
                filterOn: ['title', 'name'],
                attachment_to_delete: null,
                statuses: ['DRAFT', 'SUBMITTED']
            };
        },
        mounted() {
            this.init();
        },
        methods: {
            async init() {
                await this.getAttachments()
            },
            async getAttachments() {
                try {
                    $(".preloader").fadeIn();
                    let {data} = await this.$http.get('/marketplaces/' + this.currentOrg.marketplace_id + '/attachments');
                    this.attachments = data;
                    this.totalRows = this.attachments.length;
                } catch (e) {
                    console.error(e)
                } finally {
                    $(".preloader").fadeOut();
                }
            },
            async getFinancialYears() {
                try {
                    let {data} = await this.$http.get('/marketplaces/' + this.currentOrg.marketplace_id + '/financialreports/financialyears');
                    this.financial_year_list = data.financial_years;

                } catch (e) {

                }
            },
            pageHandler(pageNum) {
                this.getAttachments(pageNum);
            },
            setPageCount() {
                this.pageCount = this.total <= 10 ? 1 : Math.ceil(this.total / 10);
            },
            onFiltered(filteredItems) {
                this.totalRows = filteredItems.length
                this.currentPage = 1
            },
            async removeAttachment() {
                if (this.attachment_to_delete) {
                    try {
                        $(".preloader").fadeIn();
                        await this.$http.delete('/marketplaces/' + this.currentOrg.marketplace_id + '/attachments/', {
                            data: {
                                docid: this.attachment_to_delete.id,
                                filepath: this.attachment_to_delete.url
                            }
                        });
                        await this.init();
                        this.$toastr('success', 'Attachment successfully removed', 'Success');
                    } catch (e) {
                        this.$toastr('error', 'Attachment removing failed!', 'Failed');
                    } finally {
                        $(".preloader").fadeOut();
                        $("#deleteModal").modal('hide');
                    }
                }
            },
            reset() {
                this.filter = null;
                this.filter_financial_year = null;
                this.getAttachments()
            },
            async downloadFile(file) {
                try {
                    let {data} = await this.$http.get(`/marketplaces/${this.currentOrg.marketplace_id}/signedurl`, {
                        params: {
                            name: file.name,
                            type: 'read',
                            docid: file.id
                        }
                    });
                    let link = document.createElement('a');
                    link.download = file.name;
                    link.href = data.url;
                    link.click();
                } catch (e) {

                }
            },
        }
    }
</script>

<style scoped>

</style>
